import React from 'react';
import { BookOpenIcon, CompassIcon, NotebookPenIcon, ShieldIcon, WavesIcon } from 'lucide-react';
import { stack, type StackItem } from '../data/content';
import { SectionHeading } from './SectionHeading';
const icons: Record<StackItem['icon'], typeof BookOpenIcon> = {
  book: BookOpenIcon,
  spiral: WavesIcon,
  compass: CompassIcon,
  shield: ShieldIcon,
  notebook: NotebookPenIcon
};
export function ProductStack() {
  return <section aria-labelledby="contenido" className="w-full bg-ink" data-id="element-139" data-mp="dc70i1y7ujkm">
      <div className="mx-auto max-w-content px-5 py-10 sm:py-16 lg:py-24" data-id="element-140" data-mp="ibjsf13y2gu2">
        <SectionHeading eyebrow="Contenido del producto" title="¿Qué hay dentro del Master Kit Memorias del Alma™?" data-id="element-141" data-mp="n2rx5jubxe0w" />

        <ul className="mt-7 divide-y divide-line border-t border-line sm:mt-12" data-id="element-142" data-mp="r4wq0gcye6mh">
          {stack.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="grid gap-4 py-7 sm:grid-cols-[auto_1fr_1fr] sm:items-start sm:gap-8" data-id="element-143" data-mp="w1dh9jfg913s">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-line bg-ink-raised text-amethyst" data-id="element-144" data-mp="1j19fp8ici28n">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-145" data-mp="1e14ux6aemlcm" />
                </span>
                <h3 className="font-sans text-[17px] font-semibold leading-snug text-cream" data-id="element-146" data-mp="19zt44xfsnu2u">
                  {item.title}
                </h3>
                <p className="text-[15px] leading-relaxed text-muted" data-id="element-147" data-mp="153cj4c3w5vtz">{item.detail}</p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}